import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sales-goals'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'sales_goals_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'sales_goals_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'sales_goals_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
